
function compareArrays(a, b) {
    if (a.length !== b.length) {
        return false;
    }

    for (let i = 0; i < a.length; i++) {
        if (a[i] !== b[i]) {
            return false;
        }
    }

    return true;
}

function compareUnsortedArrays(a, b) {
    if (a.length !== b.length) {
        return false;
    }

    const sa = [...a].sort();
    const sb = [...b].sort();

    for (let i = 0; i < sa.length; i++) {
        if (sa[i] !== sb[i]) {
            return false;
        }
    }

    return true;
}

function comparePrimitivesOrArrays(a, b) {
    if (a instanceof Array && b instanceof Array) {
        return compareArrays(a, b);
    }

    return a === b;
}

function comparePrimitivesOrUnsortedArrays(a, b) {
    if (a instanceof Array && b instanceof Array) {
        return compareUnsortedArrays(a, b);
    }

    return a === b;
}

export {
    compareArrays,
    compareUnsortedArrays,
    comparePrimitivesOrArrays,
    comparePrimitivesOrUnsortedArrays,
};
